(function () {

    'use strict';

    angular.module('FotocApp')

        .component('filters', {


            templateUrl: (USE_TEMPLATE_CACHE ? '' : window.BASE_PATH + '../../src/') + 'editor/tools/filters.component.html',
            bindings: {},
            controller: ['$scope', '$editorService', '$canvasService', '$http', 'CONSTANTS', '$timeout', '$q', '$lang', function ($scope, $editorService, $canvasService, $http, CONSTANTS, $timeout, $q, $lang) {
                this.$editorService = $editorService;
                $scope.$lang = $lang;
                var makeingFilter = false;
                var filterCheckCounter = 0
                this.$onInit = function () {
                    var clearWatch = $scope.$watch('$ctrl.$editorService.ui.toolOpen', function () {
                        if ($editorService.ui.toolOpen === 'filters') {
                            clearWatch();
                            $timeout(function () {
                                $editorService.ui.filters = $editorService.siteConfig.filters.styles.slice(0, 59);
                            }, 400);
                        }
                    });
                }

                function setTimerSubmission($id_submission, $editingItem, $cache) {
                    try {
                        clearTimeout($editorService.ui.intervalSubmission[$editingItem]);
                    } catch (e) {
                        console.warn(e);
                    }

                    $editorService.ui.intervalSubmission[$editingItem] = setTimeout(function () {

                        if (typeof ($id_submission) === 'undefined') {
                            return;
                        }

                        $http.get(FOTOCEDITOR_FILTERS_PROXY + "?submissionId=" + $id_submission + $cache).then(function (response) {
                                if (response.data.status === "finished") {
                                    if ($editorService.data.images[$editingItem].filter != null) {
                                        $canvasService.setImageWithFilter(response.data.filteredImage, false, $editingItem);
                                        $editorService.setCacheFilter($editingItem);
                                    }
                                    makeingFilter = false;

                                } else if (response.data.status === "error") {
                                    alert('Error al cargar el filtro (code 1)')
                                    $canvasService.isLoading = false;
                                    makeingFilter = false;
                                } else {
                                    if (filterCheckCounter < 2) {
                                        filterCheckCounter++;
                                        setTimerSubmission($id_submission, $editingItem, $cache)
                                    } else {
                                        $canvasService.isLoading = false;
                                        makeingFilter = false;
                                    }
                                }
                            },

                            function (response) {

                                makeingFilter = false;
                                alert('Error al cargar el filtro: ' + response.data.message)
                                $canvasService.isLoading = false;

                            });


                    }, 7000)

                }

                this.selectFilter = function ($item) {
                    if (makeingFilter) {
                        alert('Aun estamos preocesando uno ...');
                        return;
                    }

                    var editingItem = $editorService.ui.editingItem;
                    var image_url = $editorService.getImageEditing().urlWithoutFilter;

                    filterCheckCounter = 0;
                    $canvasService.isLoading = true;
                    $editorService.getImageEditing().filter = $item;
                    $editorService.getImageEditing().userForce = true;

                    if ($item == null) {
                        $canvasService.setImageWithFilter(image_url, false);
                        return;
                    }

                    if (angular.isDefined($editorService.ui.cacheFilters[image_url]) && angular.isDefined($editorService.ui.cacheFilters[image_url][$item.id])) {
                        $canvasService.setImageWithFilter($editorService.ui.cacheFilters[image_url][$item.id]);
                        return;
                    }

                    try {
                        clearTimeout($editorService.ui.intervalSubmission[editingItem]);
                    } catch (e) {
                        console.warn(e);
                    }

                    uploadImage(image_url, $item, editingItem)


                }

                function addCacheOnFilter($hash) {


                    if ($editorService.getImageEditing().type === 'stock') {
                        return '&c=' + $hash;
                    } else if ($editorService.getImageEditing().type === 'my_galery' && $editorService.getImageEditing().data.fotocOwner) {
                        return '&c=' + $hash;
                    } else {
                        return "";
                    }
                }

                function uploadImage(image_url, $item, editingItem) {
                    makeingFilter = true;
                    $http.get(FOTOCEDITOR_FILTERS_PROXY + '?filter=' + $item.id + '&u=' + encodeURIComponent(image_url) + '&type=' + $editorService.getImageEditing().type).then(function (response) {
                            if (response.data.status === "finished") {
                                if ($editorService.data.images[editingItem].filter != null) {
                                    $canvasService.setImageWithFilter(response.data.filteredImage, false, editingItem);
                                    $editorService.setCacheFilter(editingItem);
                                }
                                makeingFilter = false;
                            } else {
                                setTimerSubmission(response.data.submissionId, editingItem, addCacheOnFilter(response.data.cache))
                            }
                        },
                        function (response) {
                            makeingFilter = false;
                            alert('Error al cargar el filtro: ' + response.data.message)
                            $canvasService.isLoading = false;
                        });
                }
            }]
        })
})();